import { render, staticRenderFns } from "./GerenciadorComparativo.vue?vue&type=template&id=2bbe8de0&scoped=true"
import script from "./GerenciadorComparativo.vue?vue&type=script&lang=js"
export * from "./GerenciadorComparativo.vue?vue&type=script&lang=js"
import style0 from "./GerenciadorComparativo.vue?vue&type=style&index=0&id=2bbe8de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe8de0",
  null
  
)

export default component.exports